import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import api from "./api";
import VueCookies from "vue-cookies";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 多國語系
    lang: null,

    // 國家
    countryOptions: [],
    // 縣市
    cityOptions: [],
    // 履歷完整度
    resumeCompleteness: {},
    // 學校
    schoolOptions: [],
    // 科系
    majorOptions: [],
    // 語言
    languageOptions: [],
    // 履歷分類標籤
    resumeTagOptions: [],
    // 其他分類
    freeTagOptions: [],
    // 過往應徵職缺
    positionOptions: [],


    sidebarShow: "responsive",
    isOpen: false,
    isSmOpen: false,

    isLoading: false,

    subMenu: [], // 選單(子選單)

    // 履歷歷程
    resumeSummary: {},

    LetterCategory: localStorage.getItem("LetterCategory"), // 信件範本
    LetterCategoryName: localStorage.getItem("LetterCategoryName"), // 信件範本名稱
    LetterEditGuid: localStorage.getItem("LetterEditGuid"), // 信件範本編輯的那一筆Guid

    // 檢視需求單
    demandDetailModalNo: null,
    // API 回應資訊
    showResponseData: false,
    showJobIntentionMail: false,
    // 面談邀約
    showInterviewMail: false,
    // 預覽信件
    showPreviewMail: false,
    // 重新邀約
    showReinviteMail: false,
    // 感謝函
    showThanksMail: false,
    // 查詢結果全選
    searchResult: false,
    // 聯繫資訊
    showContactInfo: false,
    // hcp Modal
    showHcpData: false,
    // 面談評估 Modal
    showEvaluateInterview: false,
    // scroll
    isScroll: false,
    // 錄取通知
    showHireMail: false,
    // 報到通知
    showReportMail: false,
    // 履歷 Note
    showResumeNote: false,
    // 履歷分類
    showResumeCategory: false,
    // 檢視歷程
    candidateProcessId: false,

    QueryKeyword: localStorage.getItem("QueryKeyword"), //快速查詢的搜尋欄位資料

    demandApply: false, // 新增需求申請後跳轉

    DemandNo: null, // 取得需求單號
    ResumeList: 0, // 履歷數量
    Interviewing: 0, // 待面談數量
    Interviewed: 0, // 已面談數量
    DeclineInterview: 0, // 面談未到數量
    InterviewResult: 0, // 面談結果數量
    AppointResult: 0, // 任用結果數量

    onTheJob: null, // 晶元履歷(無工作經驗<=>在職中)

    editMenu: false, // 選單變更

    // 飛騰同步
    openSCS: false,

    // K2 系統
    openK2: false,

    skillStatus: {
      isNew: false,
      background: "#3c4b64",
      fontColor: "#fff",
    },
  },
  actions: {
    sidebarOpen({ commit }, payload) {
      commit("SIDEBAR_OPEN", payload);
    },

    sidebarClose({ commit }, payload) {
      commit("SIDEBAR_CLOSE", payload);
    },

    updateLoading(context, payload) {
      context.commit("LOADING", payload);
    },

    getDemandNo(context, id) {
      context.commit("GETDEMANDNO", id);
    },

    updateDemandApply({ commit }, payload) {
      commit("UPDATEDEMANDAPPLY", payload);
    },

    // 是否開啟飛騰系統
    openSCS({ commit }) {
      const api = `${window.endpoints.api}/BasicInformation/Scs/isEnable`;
      axios.get(api).then((response) => {
        commit("OPENSCS", response.data);
      });
    },

    // 是否開啟 K2 系統
    openK2({ commit }) {
      const api = `${window.endpoints.api}/BasicInformation/K2/isEnable`;
      axios.get(api).then((response) => {
        commit("OPENK2", response.data);
      });
    },

    // 取得職缺匹配履歷狀況
    getResumeSummary({ commit }, matchId) {
      api.jobManagement.getResumeSummary(matchId).then((response) => {
        if (response.status === 200) {
          commit("RESUME_SUMMARY", response.data);
        }
      });
    },

    // 取得 國家
    GetCountry({ commit }) {
      api.country.getCountry().then(
        (response) => {
          let country = response.data.map((item) => {
            return {
              Guid: item.Guid,
              Name: item.Name,
            };
          });
          commit("GET_COUNTRY", country);
        }
      );
    },

    // 取得 縣市
    GetCity({ commit }) {
      api.address.getCity().then(
        (response) => {
          let city = response.data.map((item) => {
            return {
              Guid: item.Guid,
              Name: item.Name,
            };
          });
          commit("GET_CITY", city);
        }
      );
    },

    // 取得 履歷完整度
    GetResumeCompleteness({ commit }) {
      api.resume.getResumeCompleteness(VueCookies.get("candidateId")).then(
        (response) => {
          commit("GET_RESUME_COMPLETENESS", response.data);
        }
      );
    },

    // 取得 學校
    GetSchool({ commit }) {
      api.education.getSchool().then(
        (response) => {
          let school = response.data.map((item) => {
            return {
              Guid: item.Guid,
              Name: item.Name,
            };
          });
          commit("GET_SCHOOL", school);
        }
      );
    },

    // 取得 科系
    GetMajor({ commit }) {
      api.education.getMajor().then(
        (response) => {
          let major = response.data.map((item) => {
            return {
              Guid: item.Guid,
              Name: item.Name,
            };
          });
          commit("GET_MAJOR", major);
        }
      );
    },

    // 取得 語言
    GetLanguage({ commit }) {
      api.language.getLanguage().then(
        (response) => {
          let language = response.data.map((item) => {
            return {
              Guid: item.Guid,
              Name: item.Name,
            };
          });
          commit("GET_LANGUAGE", language);
        }
      );
    },

    // 取得 履歷分類標籤
    GetResumeTag({ commit }) {
      api.resumeTag.getResumeTag().then(
        (response) => {
          let resumeTag = response.data;
          commit("GET_RESUME_TAG", resumeTag);
        }
      );
    },

    // 取得 其他分類標籤
    GetFreeTag({ commit }) {
      api.resumeTag.getFreeTag().then(
        (response) => {
          let freeTag = response.data;
          commit("GET_FREE_TAG", freeTag);
        }
      );
    },

    // 取得 過往應徵職缺
    GetPosition({ commit }) {
      api.InterviewSch.getLogicPosition().then(
        (response) => {
          let position = response.data.Data          ;
          commit("GET_POSITION", position);
        }
      );
    },

    // 取得職缺各種狀態數量
    GetJobManagementCount({ commit }) {
      const demandNo = JSON.parse(localStorage.getItem("ResumeCard")).DemandNo;
      const api = `${window.endpoints.api}/Recruitment/JobManagementCount/${demandNo}`;
      axios.get(api).then((response) => {
        console.log(response.data)
        localStorage.setItem("ResumeListTotal", response.data.ResumeViewCount);
        localStorage.setItem("InterviewingTotal", response.data.InInterviewCount);
        localStorage.setItem("InterviewedTotal", response.data.InterviewedCount);
        localStorage.setItem("DeclineInterviewTotal", response.data.InterviewNotArrivedCount);
        localStorage.setItem("InterviewResultTotal", response.data.InterviewResultCount);
        localStorage.setItem("AppointResultTotal", response.data.AppointmentResultCount);
        commit("RESUMELIST", localStorage.ResumeListTotal);
        commit("INTERVIEWING", localStorage.InterviewingTotal);
        commit("INTERVIEWED", localStorage.InterviewedTotal);
        commit("DECLINEINTERVIEW", localStorage.DeclineInterviewTotal);
        commit("INTERVIEWRESULT", localStorage.InterviewResultTotal);
        commit("APPOINTRESULT", localStorage.AppointResultTotal);
      });
    },


    // 履歷數量
    ResumeList({ commit }) {
      const demandNo = JSON.parse(localStorage.getItem("ResumeCard")).DemandNo;
      const api = `${window.endpoints.api}/Recruitment/JobManagementByResumeView/V2/paging`;
      const params = {
        IsPaging: false,        
        ManpowerDemandNo:demandNo
      };
      axios.post(api,params).then((response) => {
        localStorage.setItem("ResumeListTotal", response.data.Quantity);
        commit("RESUMELIST", localStorage.ResumeListTotal);
      });
    },

    // 待面談
    Interviewing({ commit }) {
      const demandNo = JSON.parse(localStorage.getItem("ResumeCard")).DemandNo;
      const api = `${window.endpoints.api}/Recruitment/JobManagementByInInterview/V2/paging/${demandNo}`;
      const params = {
        IsPaging: false,
      };
      axios.get(api, { params }).then((response) => {
        localStorage.setItem("InterviewingTotal", response.data.Quantity);
        commit("INTERVIEWING", localStorage.InterviewingTotal);
      });
    },

    // 已面談
    Interviewed({ commit }) {
      const demandNo = JSON.parse(localStorage.getItem("ResumeCard")).DemandNo;
      const api = `${window.endpoints.api}/Recruitment/JobManagementByInterviewed/V2/paging/${demandNo}`;
      const params = {
        IsPaging: false,
      };
      axios.get(api, { params }).then((response) => {
        localStorage.setItem("InterviewedTotal", response.data.Quantity);
        commit("INTERVIEWED", localStorage.InterviewedTotal);
      });
    },

    // 面談未到
    DeclineInterview({ commit }) {
      const demandNo = JSON.parse(localStorage.getItem("ResumeCard")).DemandNo;
      const api = `${window.endpoints.api}/Recruitment/JobManagementByInterviewNotArrived/paging/${demandNo}`;
      const params = {
        IsPaging: false,
      };
      axios.get(api, { params }).then((response) => {
        localStorage.setItem("DeclineInterviewTotal", response.data.Quantity);
        commit("DECLINEINTERVIEW", localStorage.DeclineInterviewTotal);
      });
    },

    // 面談結果
    InterviewResult({ commit }) {
      const demandNo = JSON.parse(localStorage.getItem("ResumeCard")).DemandNo;
      const api = `${window.endpoints.api}/Recruitment/JobManagementByInterviewResult/paging/${demandNo}`;
      const params = {
        IsPaging: false,
      };
      axios.get(api, { params }).then((response) => {
        localStorage.setItem("InterviewResultTotal", response.data.Quantity);
        commit("INTERVIEWRESULT", localStorage.InterviewResultTotal);
      });
    },

    // 任用結果
    AppointResult({ commit }) {
      const demandNo = JSON.parse(localStorage.getItem("ResumeCard")).DemandNo;
      const api = `${window.endpoints.api}/Recruitment/JobManagementByAppointmentResult/paging/${demandNo}`;
      const params = {
        IsPaging: false,
      };
      axios.get(api, { params }).then((response) => {
        localStorage.setItem("AppointResultTotal", response.data.Quantity);
        commit("APPOINTRESULT", localStorage.AppointResultTotal);
      });
    },
  },

  mutations: {
    // 取得 國家
    GET_COUNTRY(state, payload) {
      state.countryOptions = payload;
    },

    // 取得 縣市
    GET_CITY(state, payload) {
      state.cityOptions = payload;
    },

    GET_RESUME_COMPLETENESS(state, payload) {
      state.resumeCompleteness = payload;
    },

    // 取得 學校
    GET_SCHOOL(state, payload) {
      state.schoolOptions = payload;
    },

    // 取得 科系
    GET_MAJOR(state, payload) {
      state.majorOptions = payload;
    },

    // 取得 語言
    GET_LANGUAGE(state, payload) {
      state.languageOptions = payload;
    },

    // 取得 履歷分類標籤
    GET_RESUME_TAG(state, payload) {
      state.resumeTagOptions = payload;
    },

    // 取得 其他分類標籤
    GET_FREE_TAG(state, payload) {
      state.freeTagOptions = payload;
    },

    // 取得 過往應徵職缺
    GET_POSITION(state, payload) {
      state.positionOptions = payload;
    },

    // 選擇 語系
    SELECT_LANGUAGE(state, payload) {
      state.lang = payload;
    },

    LOADING(state, status) {
      state.isLoading = status;
    },

    // 選單(子選單)
    SUBMENU(state, payload) {
      state.subMenu = payload;
    },

    // 晶元履歷
    ONTHEJOB(state, payload) {
      state.onTheJob = payload;
    },

    // 新增需求申請後跳轉
    UPDATEDEMANDAPPLY(state, payload) {
      state.demandApply = payload;
    },

    // 飛騰同步
    OPENSCS(state, payload) {
      state.openSCS = payload;
    },

    // K2同步
    OPENK2(state, payload) {
      state.openK2 = payload;
    },

    RESUME_SUMMARY(state, payload) {
      state.resumeSummary = payload;
    },

    // 取得需求單編號
    GETDEMANDNO(state, payload) {
      state.DemandNo = payload;
    },

    // 履歷數量
    RESUMELIST(state, payload) {
      state.ResumeList = payload;
    },
    // 待面談
    INTERVIEWING(state, payload) {
      state.Interviewing = payload;
    },
    // 已面談
    INTERVIEWED(state, payload) {
      state.Interviewed = payload;
    },
    // 面談未到
    DECLINEINTERVIEW(state, payload) {
      state.DeclineInterview = payload;
    },
    // 面談結果
    INTERVIEWRESULT(state, payload) {
      state.InterviewResult = payload;
    },
    // 任用結果
    APPOINTRESULT(state, payload) {
      state.AppointResult = payload;
    },

    // 信件範本種類
    Letter(state, payload) {
      localStorage.setItem("LetterCategory", payload);
      state.LetterCategory = localStorage.getItem("LetterCategory");
    },
    //信件範本種類名稱
    LetterName(state, payload) {
      localStorage.setItem("LetterCategoryName", payload);
      state.LetterCategoryName = localStorage.getItem("LetterCategoryName");
    },
    //編輯的那一筆guid
    LetterGuid(state, payload) {
      localStorage.setItem("LetterEditGuid", payload);
      state.LetterEditGuid = localStorage.getItem("LetterEditGuid");
    },

    //快速查詢的搜尋欄位資料
    QueryKeyword(state, payload) {
      localStorage.setItem("QueryKeyword", payload);
      state.QueryKeyword = localStorage.getItem("QueryKeyword");
    },

    // 選單變更
    EDITMENU(state, payload) {
      state.editMenu = payload;
    },

    // 檢視需求單
    OpenDemandDetailModal(state, payload) {
      state.demandDetailModalNo = payload;
    },

    // 檢視歷程
    OpenCandidateProcessModal(state, payload) {
      state.candidateProcessId = payload;
    },

    // 檢視履歷 Note
    OpenResumeNoteModal(state, payload) {
      state.showResumeNote = payload;
    },

    // 履歷分類
    OpenResumeCategoryModal(state, payload) {
      state.showResumeCategory = payload;
    },

    // 職缺意願
    OpenJobIntentionModal(state, payload) {
      state.showJobIntentionMail = payload;
    },

    // 面談邀約
    OpenInterviewMailModal(state, payload) {
      state.showInterviewMail = payload;
    },

    // 預覽信件
    OpenPreviewMailModal(state, payload) {
      state.showPreviewMail = payload;
    },

    // 重新邀約
    OpenReinviteMailModal(state, payload) {
      state.showReinviteMail = payload;
    },

    // 感謝函
    OpenThanksMailModal(state, payload) {
      state.showThanksMail = payload;
    },

    // 查詢結果全選
    OpenSearchResultModal(state, payload) {
      state.searchResult = payload;
    },

    // 聯繫資訊
    OpenContactInfoModal(state, payload) {
      state.showContactInfo = payload;
    },
    
    // HCP
    OpenHcpDataModal(state, payload) {
      state.showHcpData = payload;
    },

    // 面談評估
    OpenEvaluateInterviewModal(state, payload) {
      state.showEvaluateInterview = payload;
    },

    // scroll
    ScrollTop(state, payload) {
      state.isScroll = payload;
    },

    // 錄取通知
    OpenHireMailModal(state, payload) {
      state.showHireMail = payload;
    },

    // 報到通知
    OpenReportMailModal(state, payload) {
      state.showReportMail = payload;
    },

    // API 回應資訊
    OpenResponseDataModal(state, payload) {
      state.showResponseData = payload;
    },

    SIDEBAR_OPEN(state, payload) {
      state.isOpen = payload;
    },

    SIDEBAR_CLOSE(state, payload) {
      state.isSmOpen = payload;
    }
  },
  getters: {
    isLoading: (state) => state.isLoading,
    lang: (state) => state.lang, // 多國語系
    demandDetailModalNo: (state) => state.demandDetailModalNo, // 檢視需求單 Modal
    showResponseData: (state) => state.showResponseData, // API 回應資訊 Modal
    showResumeNote: (state) => state.showResumeNote, // 檢視履歷 Note Modal
    resumeSummary: (state) => state.resumeSummary, // 履歷 Note
    showResumeCategory: (state) => state.showResumeCategory, // 檢視分類 Modal
    candidateProcessId: (state) => state.candidateProcessId, // 檢視需求單 Modal
    showJobIntentionMail: (state) => state.showJobIntentionMail, // 職缺意願 Modal
    showInterviewMail: (state) => state.showInterviewMail, // 面談邀約 Modal
    showPreviewMail: (state) => state.showPreviewMail, // 預覽 Modal
    showReinviteMail: (state) => state.showReinviteMail, // 重新邀約 Modal
    showThanksMail: (state) => state.showThanksMail, // 感謝函 Modal
    searchResult: (state) => state.searchResult, // 查詢結果全選 Modal
    showContactInfo: (state) => state.showContactInfo, // 聯繫資訊 Modal
    showHcpData: (state) => state.showHcpData, // hcp Modal
    showEvaluateInterview: (state) => state.showEvaluateInterview, // 面談評估 Modal
    isScroll: (state) => state.isScroll, // scroll
    showHireMail: (state) => state.showHireMail, // 錄取通知 Modal
    showReportMail: (state) => state.showReportMail, // 報到通知 Modal
    editMenu: (state) => state.editMenu, // 選單變更
    onTheJob: (state) => state.onTheJob, // 晶元履歷(在職中<=>無工作經歷)
    countryOptions: (state) => state.countryOptions, // 取得國家
    cityOptions: (state) => state.cityOptions, // 取得縣市
    resumeCompleteness: (state) => state.resumeCompleteness, // 取得履歷完整度
    schoolOptions: (state) => state.schoolOptions, // 取得學校
    majorOptions: (state) => state.majorOptions, // 取得科系
    languageOptions: (state) => state.languageOptions, // 取得語言
    resumeTagOptions: (state) => state.resumeTagOptions, // 取得履歷分類標籤
    freeTagOptions: (state) => state.freeTagOptions, // 取得其他分類標籤
    positionOptions: (state) => state.positionOptions // 取得過往應徵職缺
  },
});
